import { Check, X } from "@phosphor-icons/react";

import WorkspaceImage from "common/components/WorkspaceImage";
import useInvitationMutations from "common/datahooks/useInvitationMutations";
import type { Invitation } from "common/types";

const buttonClassName =
  "size-4 text-black-500 hover:bg-black-300 rounded focus-visible:bg-white flex justify-center items-center transition-[background]";

export default function InvitationItem({
  invitation,
}: {
  invitation: Invitation;
}) {
  const {
    workspace_id: workspaceId,
    workspace_name: workspaceName,
    workspace_icon_url: imageUrl,
    token,
  } = invitation;

  const { respondToInvitation, isRespondingToInvitation } =
    useInvitationMutations();

  function acceptInvite() {
    respondToInvitation({ accept: true, memberToken: token });
  }

  function declineInvite() {
    respondToInvitation({ accept: false, memberToken: token });
  }

  return (
    <div className="group h-10 flex items-center gap-1.5 rounded-2xl border border-black-200 transition-[background] px-1.5 py-1">
      <WorkspaceImage id={workspaceId} size="xs" imageSrc={imageUrl} />
      <div>
        <span className="line-clamp-1 break-all text-left text-xs-bold">
          {workspaceName}
        </span>
        <span className="text-xxs text-purple-600">
          Invited by <span className="text-xxs-bold">Test</span>
        </span>
      </div>

      <div className="ml-auto flex flex-col">
        <button
          type="button"
          onClick={acceptInvite}
          className={buttonClassName}
          disabled={isRespondingToInvitation}
          aria-label="accept workspace invitation"
        >
          <Check size={12} weight="bold" />
        </button>
        <button
          type="button"
          onClick={declineInvite}
          className={buttonClassName}
          disabled={isRespondingToInvitation}
          aria-label="decline workspace invitation"
        >
          <X size={12} weight="bold" />
        </button>
      </div>
    </div>
  );
}
